// @generated by scripts/write-version-constant.ts
export const packageVersion = '9.1.2';
